jQuery(document).ready(function ($) {
  // Check for opencart parameter on page load
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('opencart') === 'yes') {
    $('body').addClass('cart_open');
  }

  //removeCartItem
  $.fn.removeCartItem = async function (item_id) {
    var cart_item = $('[data-line-item-id="' + item_id + '"]');

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: item_id,
        quantity: 0,
      },
      beforeSend: function () {
        cart_item.addClass('loading');

        $('#cart_footer').addClass('loading');
        $('#cart_footer').find('.button').addClass('disabled');
      },
      success: async function (response) {
        cart_item.slideUp(300, function () {
          cart_item.remove();
          $.fn.updateCart();
        });
      },
      error: function (xhr, status, error) {
        console.error('Error removing the product from the cart:', error);
      },
    });
  };

  //updateCart
  $.fn.updateCart = async function () {
    setTimeout(async function () {
      $('#cart-drawer').removeClass('loading');

      // Fetch cart drawer content
      const res = await fetch('/?section_id=gw-cart-drawer');
      const text = await res.text();
      $('#cart_drawer_wrapper').html(text);

      // Fetch current cart state
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Actualizar el contador de items
      $('#cart_trigger_count').text(cart.item_count);

      // Calcular y mostrar el descuento total
      const totalDiscount = cart.total_discount;

      if (totalDiscount > 0) {
        $('#cart_discount_value').text(`-$${formatMoney(totalDiscount)}`);
      } else {
        $('#cart_discount_value').text('-');
      }

      if (cart.item_count == 0) {
        $('#cart_trigger_count').hide();
        $('#cart-drawer').addClass('is-empty');
      } else {
        $('#cart_trigger_count').show();
        $('#cart-drawer').removeClass('is-empty');
      }
    }, 500);
  };
  $.fn.updateCart();

  // Agregar función auxiliar para formatear dinero
  function formatMoney(cents) {
    const format = Shopify.money_format || '{{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseInt(cents || 0, 10);
    const dollars = Math.floor(value / 100);
    const cents_part = (value % 100).toString().padStart(2, '0');
    return format
      .replace('{{amount}}', `${dollars}.${cents_part}`)
      .replace('{{amount_no_decimals}}', dollars)
      .replace('{{amount_with_comma_separator}}', `${dollars},${cents_part}`);
  }

  //order_totals_total_label.
  $(document).on('click', '.order_totals_total_label', function (event) {
    event.preventDefault();

    var trigger = $(this);

    if (trigger.hasClass('active')) {
      trigger.removeClass('active');
      $('#order_details').slideUp();
    } else {
      trigger.addClass('active');
      $('#order_details').slideDown();
    }
  });

  //cart_trigger
  $(document).on('click', '[data-open-cart]', function (event) {
    event.preventDefault();
    $('body').addClass('cart_open');
  });

  //data-close-cart
  $(document).on('click', '[data-close-cart]', function (event) {
    event.preventDefault();
    $('body').removeClass('cart_open');
  });

  //data-add-to-cart
  $(document).on('click', '[data-add-to-cart]', function (event) {
    event.preventDefault();

    var product_id = $(this).data('add-to-cart');

    add_data = {
      items: [
        {
          id: product_id,
          quantity: 1,
        },
      ],
    };

    $.post('/cart/add.js', add_data)
      .done((response) => {
        console.log(response);
        $.fn.updateCart();
        $('body').addClass('cart_open');
      })
      .fail((xhr, status, error) => {
        console.error('Error adding the product to the cart:', error);
      });
  });

  //qty_decrease
  $(document).on('click', '.qty_decrease', function (event) {
    event.preventDefault();
    var qty = $(this).closest('.cart_item').find('.cart_item_quantity_input');
    var currentQty = parseInt(qty.val());

    if (currentQty > 1) {
      qty.val(currentQty - 1).change();
    }
  });

  //qty_increase
  $(document).on('click', '.qty_increase', function (event) {
    event.preventDefault();
    var qty = $(this).closest('.cart_item').find('.cart_item_quantity_input');
    var currentQty = parseInt(qty.val());
    var maxQty = parseInt(qty.attr('max')) || 99;

    if (currentQty < maxQty) {
      qty.val(currentQty + 1).change();
    }
  });

  //cart_item_quantity_input
  $(document).on('change', '.cart_item_quantity_input', function (event) {
    event.preventDefault();
    var qty = $(this).val();
    var lineItemId = $(this).closest('.cart_item').data('line-item-id');

    if (qty === '' || qty == 0) {
      $.fn.removeCartItem(lineItemId);
      return;
    }

    if (!lineItemId || isNaN(qty) || qty < 0) {
      console.error('Invalid data to update the product quantity in the cart.');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: lineItemId,
        quantity: qty,
      },
      beforeSend: function () {
        $('#cart_footer').addClass('loading');
        $('#cart_footer').find('.button').addClass('disabled');
      },
      success: async function (response) {
        $.fn.updateCart();
      },
      error: function (xhr, status, error) {
        console.error('Error updating the product quantity in the cart:', error);
      },
    });
  });

  //cart_item_quantity_input
  $(document).on('keyup', '.cart_item_quantity_input', function (event) {
    event.preventDefault();
    var newQuantity = $(this).val(),
      lineItemId = $(this).closest('.cart_item').data('line-item-id');

    if (newQuantity === '' || newQuantity == 0) {
      $.fn.removeCartItem(lineItemId);
      return;
    }

    if (!lineItemId || isNaN(newQuantity) || newQuantity < 0) {
      console.error('Invalid data to update the product quantity in the cart.');
      return;
    }

    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: lineItemId,
        quantity: newQuantity,
      },
      beforeSend: function () {
        $('#cart_footer').addClass('loading');
        $('#cart_footer').find('.button').addClass('disabled');
      },
      success: async function (response) {
        $.fn.updateCart();
      },
      error: function (xhr, status, error) {
        console.error('Error updating the product quantity in the cart:', error);
      },
    });
  });

  //data-remove-cart-item
  $(document).on('click', '[data-remove-cart-item]', async function (event) {
    event.preventDefault();

    var cart_item = $(this).closest('.cart_item'),
      lineItemId = $(cart_item).data('line-item-id');

    $.fn.removeCartItem(lineItemId);
  });

  //data-form-add-to-cart
  $(document).on('submit', '[data-type="add-to-cart-form"]', function (event) {
    event.preventDefault();

    var $form = $(this);
    var formData = $form.serialize();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: formData,
      beforeSend: function () {
        $form.find('button[type="submit"]').prop('disabled', true);
      },
      success: function (response) {
        $.fn.updateCart();

        $('body').addClass('cart_open');
        $form.find('button[type="submit"]').prop('disabled', false);
      },
      error: function (xhr, status, error) {
        console.error('Error adding the product to the cart:', error);
        $form.find('button[type="submit"]').prop('disabled', false);
      },
    });
  });

  //option_select
  $(document).on('change', '.option_select', function (event) {
    event.preventDefault();
    var selections = $('variant-selects select').serializeJSON();

    // Obtener las opciones seleccionadas
    var selectedOptions = Object.values(selections.options);

    // Buscar la variación que coincida con todas las opciones seleccionadas
    var selectedVariation = variations.find(function (variation) {
      return selectedOptions.every(function (option, index) {
        return variation[`option${index + 1}`] === option;
      });
    });

    if (selectedVariation) {
      $('[name="id"]').val(selectedVariation.id).change();
    }
  });

  // Update coupon code handler
  $(document).on('click', '#cart_coupon_code_button', function (event) {
    event.preventDefault();
    const couponCode = $('#cart_coupon_code_input').val().trim();
    const currentPath = window.location.pathname + window.location.search;

    if (!couponCode) {
      alert('Please enter a coupon code');
      return;
    }

    // Redirect to the discount URL with current page as redirect
    window.location.href =
      '/discount/' +
      couponCode +
      '?redirect=' +
      encodeURIComponent(currentPath + (currentPath.includes('?') ? '&' : '?') + 'opencart=yes');
  });

  class CartDiscounts {
    constructor() {
      this.initializeEventListeners();
    }

    initializeEventListeners() {
      // Listener para el botón de aplicar cupón
      document
        .getElementById('cart_coupon_code_button')
        ?.addEventListener('click', this.handleApplyDiscount.bind(this));

      // Listeners para los botones de eliminar cupón
      document.querySelectorAll('.remove_discount_button').forEach((button) => {
        button.addEventListener('click', this.handleRemoveDiscount.bind(this));
      });
    }

    async handleApplyDiscount() {
      const codeInput = document.getElementById('cart_coupon_code_input');
      const discountCode = codeInput.value.trim();

      if (!discountCode) return;

      try {
        const response = await fetch('/discount/' + discountCode);
        if (response.ok) {
          // Recargar el carrito para mostrar el descuento aplicado
          window.location.reload();
        } else {
          // Mostrar error
          alert('Invalid discount code');
        }
      } catch (error) {
        console.error('Error applying discount:', error);
        alert('Error applying discount');
      }
    }

    async handleRemoveDiscount(event) {
      const button = event.currentTarget;
      const discountCode = button.dataset.discountCode;

      try {
        const response = await fetch('/discount/clear');
        if (response.ok) {
          const otherDiscounts = Array.from(document.querySelectorAll('.remove_discount_button'))
            .map((btn) => btn.dataset.discountCode)
            .filter((code) => code !== discountCode);

          for (const code of otherDiscounts) {
            await fetch('/discount/' + code);
          }

          window.location.reload();
        }
      } catch (error) {
        console.error('Error removing discount:', error);
        alert('Error removing discount');
      }
    }
  }

  // Inicializar cuando el DOM esté listo
  document.addEventListener('DOMContentLoaded', () => {
    new CartDiscounts();
  });

  //data-form-add-to-cart
  $(document).on('click', '[data-remove-discount]', async function (event) {
    event.preventDefault();
    const discountCode = $(this).data('discount-code');

    $('#cart-drawer').addClass('loading');

    try {
      const response = await fetch('/discount/clear');
      if (response.ok) {
        const otherDiscounts = $('.remove_discount_button')
          .map(function () {
            return $(this).data('discount-code');
          })
          .get()
          .filter((code) => code !== discountCode);

        for (const code of otherDiscounts) {
          await fetch('/discount/' + code);
        }

        $.fn.updateCart();
      }
    } catch (error) {
      console.error('Error removing discount:', error);
      alert('Error removing discount');
    }
  });
});
